import React, { useState, useEffect } from "react";
import {
    Grid,
    Typography,
    Button,
    TextField,
    MenuItem,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TablePagination,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Checkbox,
    FormControlLabel,InputLabel,FormControl,
} from "@mui/material";
import { Tooltip } from "antd";
import moment from "moment";

// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// import {
//     MuiPickersUtilsProvider,
//     DatePicker
// } from "@mui/material/pickers";

import ThumbUpAltRoundedIcon from "@mui/icons-material/ThumbDownAltRounded"
import ClearRoundedIcon from "@mui/icons-material/ClearRounded";
import { NavLink } from "react-router-dom";
import Layout from "../../components/Wrappers/Layout";
import { Card, Alert } from "reactstrap";
// import { AiOutlineSearch } from "react-icons/ai";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@mui/styles";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import { useHistory, useNavigate } from "react-router-dom";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import SearchIcon from "@mui/icons-material/Search";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import "../../components/LoadingSpinner/spinner.css";
import { partnerWithdrawReqList } from '../../redux/actions/withdrawReqListForPartnerAction';
import { partnerWithdrawApproveRejectList } from "../../redux/actions/withdrawApproveRejectAction"
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import SOLogout from "../../components/Logout/SOLogout";
import Util from "../../validation/index";
import FileBase64 from "../../components/Upload/UploadFile";
import { partnerBankNameListReqList } from '../../redux/actions/bankNameListPartnerAction';
import { partnerBranchNameListReqList } from "../../redux/actions/branchNameListPartnerAction"
const useStyles = makeStyles({
    table: {
        minWidth: 650
    }
});


const WithdrawMoney = () => {
    const navigate = useHistory();
    const regenerateTokenRes = useSelector(
        ({ regenerateToken }) => regenerateToken
    );
    var authToken = regenerateTokenRes.data.AuthToken;
    const classes = useStyles();
    const dispatch = useDispatch();
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [isLoading, setIsLoading] = useState(true);
    const [notificationOpen, setNotificationOpen] = useState(false);

    const [withdrawEMoneyListArray, setWithdrawEMoneyListArray] = useState("");

    const [withdrawEMoneyListStatus, setWithdrawEMoneyListStatus] =
        useState(false);

    const [getWithdrawApprovedorRejectStatus, setGetWithdrawApprovedorRejectStatus] =
        useState(false);
    const [getWithdrawApprovedorRejectArray, setGetWithdrawApprovedorRejectArray] =
        useState("");
    const [openRejectReason, setOpenRejectReason] = React.useState(false);
    const [getRemark, setGetRemark] = useState("");
    const [modalRequestid, setmodalRequestid] = useState('');

    const partnerWithdrawEMoneyListRes = useSelector(
        ({ partnerWithdrawReqListsForPartner }) => partnerWithdrawReqListsForPartner
    );

    const partnerWithdrawApproveRejectListRes = useSelector(
        ({ partnerWithdrawApproveRejectLists }) => partnerWithdrawApproveRejectLists
    )

    const partnerBankNameRes = useSelector(({ partnerBankNameLists }) => partnerBankNameLists);

    const partnerBranchNameRes = useSelector(({ partnerBranchNameLists }) => partnerBranchNameLists);
    const [user, setUser] = useState({
        bankNameSearch: "",
        branchNameSearch: ""
    });

    const { bankNameSearch, branchNameSearch } = user;

    const onInputChange = ({ target: { name, value } }, type) => {
        const obj = {
            ...user
        };

        if (type == "number") {
            obj[name] = Util.verifyMobile(value) ? value : obj[name];
        } else if (type == "alphabet") {
            obj[name] = Util.verifyAlphabet(value) ? value : obj[name];
        } else if (type == "both") {
            obj[name] = Util.alphaNumeric(value) ? value : obj[name];
        } else {
            obj[name] = value
        }
        setUser(obj);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    const handleClose = () => {
        // setAddOpen(false);
        // setShow(false)
        setOpenRejectReason(false)
        // setRequestInput({
        // 	bankName: "",
        // 	branchName: "",
        // 	accountNum: "",
        // 	amount: ""
        // });
    };
    const handleChange = ({ target: { name, value } }) => {
        if (name === "GetRemark") {
            setGetRemark(value);
        }
    };
    const rejectOpenModal = (requestId) => {
        setOpenRejectReason(true);
        setmodalRequestid(requestId);
    }

    const withdrawEMoneyListReq = () => {
        setWithdrawEMoneyListStatus(true);
        let req = {
            actionCustomerMasterRequestVO: {
                walletOwnerId: regenerateTokenRes.data.partnerId,
                bankName: bankNameSearch.split(",")[1],
                branchName: branchNameSearch.split(",")[1]
            }
        };
        dispatch(partnerWithdrawReqList(req, authToken));
    };

    const withdrawEMoneyListFunc = () => {
        if (withdrawEMoneyListStatus) {
            if (partnerWithdrawEMoneyListRes.data.status == "success") {
                setWithdrawEMoneyListArray(
                    [].concat(partnerWithdrawEMoneyListRes.data.errorList)
                );
                setIsLoading(false);
            }
            if (partnerWithdrawEMoneyListRes.data.status == "failed") {
                setWithdrawEMoneyListArray(partnerWithdrawEMoneyListRes.data);
                setIsLoading(false);
                if (
                    partnerWithdrawEMoneyListRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    partnerWithdrawEMoneyListRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
        }
    };
    useEffect(() => {
        withdrawEMoneyListFunc();
    }, [partnerWithdrawEMoneyListRes.data.status]);

    const PartnerBankNameReq = () => {
        let req = {
            actionCustomerMasterRequestVO: {
                walletOwnerId: regenerateTokenRes.data.partnerId
            }
        };

        dispatch(partnerBankNameListReqList(req, authToken));
    };

    const PartnerBranchNameReq = () => {
        let request = {
            actionCustomerMasterRequestVO: {
                walletOwnerId: regenerateTokenRes.data.partnerId,
                // bankCode: bankName.split(",")[0] || bankNameSearch.split(",")[0]
                bankCode: bankNameSearch.split(",")[0]

            }
        };

        dispatch(partnerBranchNameListReqList(request, authToken));
    };
    useEffect(() => {
        setUser({
            bankNameSearch: bankNameSearch,
            branchNameSearch: ""
        })

        // branchNameReq();
        PartnerBranchNameReq()
    }, [bankNameSearch]);


    useEffect(() => {
        if (regenerateTokenRes.data.status == "success") {
            withdrawEMoneyListReq();
            PartnerBankNameReq()

            // bankNameReq();
        }
    }, [regenerateTokenRes.data.status]);

    const handleAcceptOrRejectReq = (
        action,
        requestId,
        // status,
        // remark,
        withdrawStatus
    ) => {
        setGetWithdrawApprovedorRejectStatus(true)
        const req = {
            actionCustomerMasterRequestVO: {
                walletOwnerId: regenerateTokenRes.data.partnerId,
                action: action,
                requestId: requestId,
                status: withdrawStatus,
                //status: status === "Approval Pending" ? "approved" : "rejected",
                remark: getRemark || "-"
            }
        };
        dispatch(partnerWithdrawApproveRejectList(req, authToken));
        setGetRemark('')

    }
    const getWithdrawApproveRejectResFunc = () => {
        if (getWithdrawApprovedorRejectStatus) {
            if (
                partnerWithdrawApproveRejectListRes.data.status == "success"
            ) {
                setGetWithdrawApprovedorRejectArray(partnerWithdrawApproveRejectListRes.data);
                setNotificationOpen(true);
                withdrawEMoneyListReq()
            }
            if (
                partnerWithdrawApproveRejectListRes.data.status == "failed"
            ) {
                setGetWithdrawApprovedorRejectArray(partnerWithdrawApproveRejectListRes.data);
                setNotificationOpen(true);
            }
        }
    };

    useEffect(() => {
        getWithdrawApproveRejectResFunc();
    }, [partnerWithdrawApproveRejectListRes.data.status]);

    const handleNoticationClose = () => {
        setNotificationOpen(false);
        setOpenRejectReason(false)

    };
    return (
        <>
            <Layout>
                <Card>
                    <Grid
                        container
                        spacing={2}
                        style={{ padding: "25px", marginTop: "2rem" }}
                    >
                        <Grid item xs={12} sm={6} md={4} lg={4}>
                            <TextField
                                select
                                size="small"
                                color="primary"
                                type="text"
                                variant="standard"
                                label="Bank Name"
                                fullWidth={true}
                                name="bankNameSearch"
                                // defaultValue={bankNameSearch || ""}
                                onChange={(e) => onInputChange(e, "")}
                            >
                                <MenuItem value="" selected="">
                                    Select Bank Name
                                </MenuItem>
                                {partnerBankNameRes.success &&
                                    []
                                        .concat(partnerBankNameRes.data.list)
                                        .map((x) => <MenuItem value={x.code + "," + x.name}>{x.name}</MenuItem>)}
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={4}>
                            <TextField
                                select
                                size="small"
                                color="primary"
                                type="text"
                                label="Branch Name"
                                variant="standard"

                                fullWidth={true}
                                name="branchNameSearch"
                                // defaultValue={branchNameSearch || ""}
                                onChange={(e) => onInputChange(e, "")}
                            >
                                <MenuItem
                                    value=""
                                    selected=""
                                >
                                    Select Branch Name
                                </MenuItem>
                                {partnerBranchNameRes.success &&
                                    []
                                        .concat(partnerBranchNameRes.data.list)
                                        .map((x) => <MenuItem value={x.code + "," + x.name}>{x.name}</MenuItem>)}
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <CustomButton
                                style={{
                                    padding: "8px"
                                }}
                                onClick={withdrawEMoneyListReq}
                            >
                                Search <SearchIcon />
                            </CustomButton>
                        </Grid>
                    </Grid>
                </Card>


                {isLoading ? (
                    <LoadingSpinner />
                ) : withdrawEMoneyListArray.length == undefined ||
                    !withdrawEMoneyListStatus ? (
                    <Card>
                        <Grid
                            container
                            style={{
                                padding: "10px"
                            }}
                        >
                            <Grid xs={12} sm={12} md={12} lg={12}>
                                <Typography variant="body1" style={{ fontWeight: "700" }}>
                                    Summary Data
                                </Typography>
                            </Grid>
                            <Grid xs={12} sm={12} md={12} lg={12}>
                                <Alert
                                    className="my-3 tableHeaderColor"
                                    variant="secondary"
                                    style={{ color: "white" }}
                                >
                                    No Records Found!
                                </Alert>
                            </Grid>
                        </Grid>
                    </Card>
                ) : (
                    <div>
                        <Card>
                            <Grid
                                container
                                style={{
                                    padding: "10px"
                                }}
                            >
                                <Grid xs={12} sm={12} md={12} lg={12}>
                                    <Typography variant="body1" style={{ fontWeight: "700" }}>
                                        Report Table
                                    </Typography>
                                </Grid>
                                <TableContainer component={Paper} className="text-nowrap my-3">
                                    <Table className={classes.table}>
                                        <TableHead>
                                            <TableRow className="tableHeaderColor">
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Request ID{" "}
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Dealer ID
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Dealer Name
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Bank Name
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Branch Name
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Account Type
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Account Number
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Amount
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Status
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Remark
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Action
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {withdrawEMoneyListArray &&
                                                []
                                                    .concat(withdrawEMoneyListArray)
                                                    .slice(
                                                        page * rowsPerPage,
                                                        page * rowsPerPage + rowsPerPage
                                                    )
                                                    .map((row, index) => (
                                                        <TableRow key={index}>
                                                            <TableCell align="center">
                                                                {row.requestId}
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {row.toCustId}
                                                            </TableCell>
                                                            <TableCell align="center">{row.toCustName}</TableCell>
                                                            <TableCell align="center">
                                                                {row.bankName}
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {row.branchName}
                                                            </TableCell>
                                                            <TableCell align="center">{row.transactionType}</TableCell>
                                                            <TableCell align="center">{row.bankAccountNumber}</TableCell>
                                                            <TableCell align="center">
                                                                {row.amount}
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {row.status}
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {row.remark}
                                                            </TableCell>
                                                            {/* {row.status == "Approval Pending" && (
                                                                <>
                                                                    <TableCell align="center">
                                                                        <Tooltip title="Approve">
                                                                            <CustomButton
                                                                                style={{
                                                                                    padding: "8px",
                                                                                    width: "50px"
                                                                                }}
                                                                                onClick={() =>
                                                                                    handleAcceptOrRejectReq(
                                                                                        // row.action,
                                                                                        row.requestId,
                                                                                        // row.status,
                                                                                        // row.remark,
                                                                                        "Approved",

                                                                                    )
                                                                                }
                                                                            >
                                                                                {
                                                                                    <ThumbUpAltRoundedIcon
                                                                                        style={{
                                                                                            color: "#fff",
                                                                                            fontSize: "20px"
                                                                                        }}
                                                                                    />
                                                                                }
                                                                            </CustomButton>
                                                                        </Tooltip>

                                                                        <Tooltip title="Reject">
                                                                            <CustomButton
                                                                                style={{
                                                                                    padding: "4px",
                                                                                    width: "48px",
                                                                                    marginLeft: "5px"
                                                                                }}
                                                                                onClick={() =>
                                                                                    handleAcceptOrRejectReq(
                                                                                        // row.action,
                                                                                        row.requestId,
                                                                                        // row.status,
                                                                                        // row.remark,
                                                                                        "Rejected",

                                                                                    )
                                                                                }
                                                                            >
                                                                                {
                                                                                    <ClearRoundedIcon
                                                                                        style={{
                                                                                            color: "#fff",
                                                                                            fontSize: "28px"
                                                                                        }}
                                                                                    />
                                                                                }
                                                                            </CustomButton>
                                                                        </Tooltip>
                                                                    </TableCell>
                                                                </>
                                                            )} */}
                                                            {row.status == "Review Pending" && (
                                                                <>
                                                                    <TableCell align="center">
                                                                        <Tooltip title="Approve">
                                                                            <CustomButton
                                                                                style={{
                                                                                    padding: "8px",
                                                                                    width: "50px"
                                                                                }}
                                                                                onClick={() =>
                                                                                    handleAcceptOrRejectReq(
                                                                                        // row.action,
                                                                                        row.status,
                                                                                        row.requestId,
                                                                                        // row.status,
                                                                                        // row.remark,
                                                                                        "Approval Pending",

                                                                                    )
                                                                                }
                                                                            >
                                                                                {
                                                                                    <ThumbUpAltRoundedIcon
                                                                                        style={{
                                                                                            color: "#fff",
                                                                                            fontSize: "20px"
                                                                                        }}
                                                                                    />
                                                                                }
                                                                            </CustomButton>
                                                                        </Tooltip>

                                                                        <Tooltip title="Reject">
                                                                            <CustomButton
                                                                                style={{
                                                                                    padding: "4px",
                                                                                    width: "48px",
                                                                                    marginLeft: "5px"
                                                                                }}
                                                                                // onClick={() =>
                                                                                //     handleAcceptOrRejectReq(
                                                                                //         row.action,
                                                                                //         row.requestId,
                                                                                //         row.status,
                                                                                //         row.remark,
                                                                                //         "reject",

                                                                                //     )
                                                                                // }
                                                                                onClick={() => {
                                                                                    rejectOpenModal(row.requestId)
                                                                                }}
                                                                            >
                                                                                {
                                                                                    <ClearRoundedIcon
                                                                                        style={{
                                                                                            color: "#fff",
                                                                                            fontSize: "28px"
                                                                                        }}
                                                                                    />
                                                                                }
                                                                            </CustomButton>
                                                                        </Tooltip>
                                                                    </TableCell>
                                                                </>
                                                            )}

                                                            {row.status == "Approval Pending" && (
                                                                <>
                                                                    <TableCell align="center">
                                                                        <Tooltip title="Approve">
                                                                            <CustomButton
                                                                                style={{
                                                                                    padding: "8px",
                                                                                    width: "50px"
                                                                                }}
                                                                                disabled={true}
                                                                            >
                                                                                {
                                                                                    <ThumbUpAltRoundedIcon
                                                                                        style={{
                                                                                            color: "#fff",
                                                                                            fontSize: "20px"
                                                                                        }}
                                                                                    />
                                                                                }
                                                                            </CustomButton>
                                                                        </Tooltip>

                                                                        <Tooltip title="Reject">
                                                                            <CustomButton
                                                                                style={{
                                                                                    padding: "4px",
                                                                                    width: "48px",
                                                                                    marginLeft: "5px"
                                                                                }}
                                                                                disabled={true}
                                                                            >
                                                                                {
                                                                                    <ClearRoundedIcon
                                                                                        style={{
                                                                                            color: "#fff",
                                                                                            fontSize: "28px"
                                                                                        }}
                                                                                    />
                                                                                }
                                                                            </CustomButton>
                                                                        </Tooltip>
                                                                    </TableCell>
                                                                </>
                                                            )}

                                                            {row.status == "Approved" && (
                                                                <>
                                                                    <TableCell align="center">
                                                                        <Tooltip title="Approve">
                                                                            <CustomButton
                                                                                style={{
                                                                                    padding: "8px",
                                                                                    width: "50px"
                                                                                }}
                                                                                disabled
                                                                            >
                                                                                {
                                                                                    <ThumbUpAltRoundedIcon
                                                                                        style={{
                                                                                            color: "#fff",
                                                                                            fontSize: "20px"
                                                                                        }}
                                                                                    />
                                                                                }
                                                                            </CustomButton>
                                                                        </Tooltip>

                                                                        <Tooltip title="Reject">
                                                                            <CustomButton
                                                                                style={{
                                                                                    padding: "4px",
                                                                                    width: "48px",
                                                                                    marginLeft: "5px"
                                                                                }}
                                                                                disabled
                                                                            >
                                                                                {
                                                                                    <ClearRoundedIcon
                                                                                        style={{
                                                                                            color: "#fff",
                                                                                            fontSize: "28px"
                                                                                        }}
                                                                                    />
                                                                                }
                                                                            </CustomButton>
                                                                        </Tooltip>
                                                                    </TableCell>
                                                                </>
                                                            )}

                                                            {row.status == "reject" && (
                                                                <>
                                                                    <TableCell align="center">
                                                                        <Tooltip title="Approve">
                                                                            <CustomButton
                                                                                style={{
                                                                                    padding: "8px",
                                                                                    width: "50px"
                                                                                }}
                                                                                disabled={true}
                                                                            >
                                                                                {
                                                                                    <ThumbUpAltRoundedIcon
                                                                                        style={{
                                                                                            color: "#fff",
                                                                                            fontSize: "20px"
                                                                                        }}
                                                                                    />
                                                                                }
                                                                            </CustomButton>
                                                                        </Tooltip>

                                                                        <Tooltip title="Reject">
                                                                            <CustomButton
                                                                                style={{
                                                                                    padding: "4px",
                                                                                    width: "48px",
                                                                                    marginLeft: "5px"
                                                                                }}
                                                                                disabled={true}
                                                                            >
                                                                                {
                                                                                    <ClearRoundedIcon
                                                                                        style={{
                                                                                            color: "#fff",
                                                                                            fontSize: "28px"
                                                                                        }}
                                                                                    />
                                                                                }
                                                                            </CustomButton>
                                                                        </Tooltip>
                                                                    </TableCell>
                                                                </>
                                                            )}
                                                            {row.status == "rejected" && (
                                                                <>
                                                                    <TableCell align="center">
                                                                        <Tooltip title="Approve">
                                                                            <CustomButton
                                                                                style={{
                                                                                    padding: "8px",
                                                                                    width: "50px"
                                                                                }}
                                                                                disabled={true}
                                                                            >
                                                                                {
                                                                                    <ThumbUpAltRoundedIcon
                                                                                        style={{
                                                                                            color: "#fff",
                                                                                            fontSize: "20px"
                                                                                        }}
                                                                                    />
                                                                                }
                                                                            </CustomButton>
                                                                        </Tooltip>

                                                                        <Tooltip title="Reject">
                                                                            <CustomButton
                                                                                style={{
                                                                                    padding: "4px",
                                                                                    width: "48px",
                                                                                    marginLeft: "5px"
                                                                                }}
                                                                                disabled={true}
                                                                            >
                                                                                {
                                                                                    <ClearRoundedIcon
                                                                                        style={{
                                                                                            color: "#fff",
                                                                                            fontSize: "28px"
                                                                                        }}
                                                                                    />
                                                                                }
                                                                            </CustomButton>
                                                                        </Tooltip>
                                                                    </TableCell>
                                                                </>
                                                            )}

                                                            {row.status == "Rejected" && (
                                                                <>
                                                                    <TableCell align="center">
                                                                        <Tooltip title="Approve">
                                                                            <CustomButton
                                                                                style={{
                                                                                    padding: "8px",
                                                                                    width: "50px"
                                                                                }}
                                                                                disabled={true}
                                                                            >
                                                                                {
                                                                                    <ThumbUpAltRoundedIcon
                                                                                        style={{
                                                                                            color: "#fff",
                                                                                            fontSize: "20px"
                                                                                        }}
                                                                                    />
                                                                                }
                                                                            </CustomButton>
                                                                        </Tooltip>

                                                                        <Tooltip title="Reject">
                                                                            <CustomButton
                                                                                style={{
                                                                                    padding: "4px",
                                                                                    width: "48px",
                                                                                    marginLeft: "5px"
                                                                                }}
                                                                                disabled={true}
                                                                            >
                                                                                {
                                                                                    <ClearRoundedIcon
                                                                                        style={{
                                                                                            color: "#fff",
                                                                                            fontSize: "28px"
                                                                                        }}
                                                                                    />
                                                                                }
                                                                            </CustomButton>
                                                                        </Tooltip>
                                                                    </TableCell>
                                                                </>
                                                            )}

                                                            {/* {row.status == "rejected" && (
                                                                <>
                                                                    <TableCell align="center">
                                                                        <Tooltip title="Reject">
                                                                            <CustomButton
                                                                                style={{
                                                                                    padding: "8px",
                                                                                    width: "50px"
                                                                                }}
                                                                                disabled={true}
                                                                            >
                                                                                {
                                                                                    <ThumbUpAltRoundedIcon
                                                                                        style={{
                                                                                            color: "#fff",
                                                                                            fontSize: "20px"
                                                                                        }}
                                                                                    />
                                                                                }
                                                                            </CustomButton>
                                                                        </Tooltip>

                                                                        <Tooltip title="Reject">
                                                                            <CustomButton
                                                                                style={{
                                                                                    padding: "4px",
                                                                                    width: "48px",
                                                                                    marginLeft: "5px"
                                                                                }}
                                                                                disabled={true}
                                                                            >
                                                                                {
                                                                                    <ClearRoundedIcon
                                                                                        style={{
                                                                                            color: "#fff",
                                                                                            fontSize: "28px"
                                                                                        }}
                                                                                    />
                                                                                }
                                                                            </CustomButton>
                                                                        </Tooltip>
                                                                    </TableCell>
                                                                </>
                                                            )} */}

                                                            {/* {row.status == "Approval Pending" && (
                                                                <>
                                                                    <TableCell align="center">
                                                                        <Tooltip title="Approve">
                                                                            <CustomButton
                                                                                style={{
                                                                                    padding: "8px",
                                                                                    width: "50px"
                                                                                }}
                                                                                disabled={true}
                                                                            >
                                                                                {
                                                                                    <ThumbUpAltRoundedIcon
                                                                                        style={{
                                                                                            color: "#fff",
                                                                                            fontSize: "20px"
                                                                                        }}
                                                                                    />
                                                                                }
                                                                            </CustomButton>
                                                                        </Tooltip>

                                                                        <Tooltip title="Reject">
                                                                            <CustomButton
                                                                                style={{
                                                                                    padding: "4px",
                                                                                    width: "48px",
                                                                                    marginLeft: "5px"
                                                                                }}
                                                                                disabled={true}
                                                                            >
                                                                                {
                                                                                    <ClearRoundedIcon
                                                                                        style={{
                                                                                            color: "#fff",
                                                                                            fontSize: "28px"
                                                                                        }}
                                                                                    />
                                                                                }
                                                                            </CustomButton>
                                                                        </Tooltip>
                                                                    </TableCell>
                                                                </>
                                                            )} */}
                                                        </TableRow>
                                                    ))}
                                        </TableBody>
                                    </Table>
                                    <TablePagination
                                        rowsPerPageOptions={[5, 10, 25]}
                                        component="div"
                                        count={[].concat(withdrawEMoneyListArray).length}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        onChangePage={handleChangePage}
                                        onChangeRowsPerPage={handleChangeRowsPerPage}
                                    />
                                </TableContainer>
                            </Grid>
                        </Card>
                    </div>
                )}



                <div>
                    <Dialog open={openRejectReason} onClose={handleClose}>
                        {/* <DialogTitle>Reject Document</DialogTitle>
                        
                        <hr /> */}
                        {/* <IconButton onClick={handleClose}>
                            <CloseIcon />
                        </IconButton> */}
                        <DialogTitle style={{ width: "400px" }}>
                            Are you sure you want to reject the document?
                        </DialogTitle>
                        <DialogActions className="p-3">
                            <Grid item xs={12} md={12} lg={12}>
                                <div style={{ marginTop: "1.5rem" }}>
                                    <TextField
                                        required
                                        type="text"
                                        size="small"
                                        color="primary"
                                        autoFocus={true}
                                        label="Reject Reason"
                                        fullWidth={true}
                                        name="GetRemark"
                                        value={getRemark || ""}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className="text-right" style={{ marginTop: "2.5rem" }}>
                                    <CustomButton
                                        style={{
                                            padding: "8px",
                                            margin: "0 8px"
                                        }}
                                        variant="contained"

                                        onClick={() =>
                                            handleAcceptOrRejectReq(
                                                // action,
                                                modalRequestid,
                                                // status,
                                                // remark,
                                                "Rejected",

                                            )
                                        }
                                    >
                                        OK
                                    </CustomButton>
                                </div>
                            </Grid>

                        </DialogActions>
                    </Dialog>
                </div>
            </Layout>

            {getWithdrawApprovedorRejectArray.status == "success" && (
                <div>
                    <Dialog open={notificationOpen} onClose={handleNoticationClose}>
                        <DialogContent className="text-center"
						style={{ backgroundColor: "#00b9f51c" }}
                        
                        >
                            <img src={success} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {getWithdrawApprovedorRejectArray.description}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <CustomButton
                                style={{
                                    padding: "8px"
                                }}
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </CustomButton>
                        </DialogActions>
                    </Dialog>
                </div>
            )}

            {getWithdrawApprovedorRejectArray.status == "failed" && (
                <div>
                    <Dialog open={notificationOpen} onClose={handleNoticationClose}>
                        <DialogContent className="text-center"
						style={{ backgroundColor: "#00b9f51c" }}
                        
                        >
                            <img src={failed} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {getWithdrawApprovedorRejectArray.description}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <CustomButton
                                style={{
                                    padding: "8px"
                                }}
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </CustomButton>
                        </DialogActions>
                    </Dialog>
                </div>
            )}
        </>
    )
}

export default WithdrawMoney